import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export enum Icons {
  ITF = 'ITF',
  GC = 'GC',
  CLIENT_OBLIGATION = 'CLIENT_OBLIGATION',
  EUROINS = 'EUROINS',
  LEV = 'LEV',
  REWARD = 'REWARD',
  PRICING_OFFER = 'PRICING_OFFER',
  GRAY_PRICE_TAG = 'GRAY_PRICE_TAG',
  ADD_ROLE_GROUP = 'ADD_ROLE_GROUP',
  ADD_ROLE = 'ADD_ROLE',
  BANK = 'BANK',
  CREDIT_LIMIT_OFFER = 'CREDIT_LIMIT_OFFER',
}

/* Steps for adding new icons
 *  - Add the new svg icons to assets/icons
 *  - Add the name to the Icons enum
 *  - Resize the icon to 24x24 if needed (it can be done in notepad)
 */

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) { }

  public registerIcons(): void {
    this.loadIcons(Object.values(Icons), 'assets/icons');
  }

  private loadIcons(iconKeys: string[], iconUrl: string): void {
    iconKeys.forEach((key) => {
      this.matIconRegistry.addSvgIcon(
        key,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `${iconUrl}/${key}.svg`
        )
      );
    });
  }
}
